import { Box, Text } from '@st/document-rendering'
import { TextAnnotation } from '@st/sdk'
import { memo } from 'react'

export const TextView = memo(TextViewBase)

type Props = {
  annotation: TextAnnotation
}

function TextViewBase({ annotation }: Props) {
  return (
    <Box width={annotation.bounds.width} height={annotation.bounds.height}>
      <Text
        fontFamily={annotation.font.family}
        fontSize={annotation.font.size}
        color={annotation.color}
        lineHeight={1.1}
      >
        {annotation.content}
      </Text>
    </Box>
  )
}
